import { Text, VStack } from '@chakra-ui/react'

import { BookingFlowErrorLayout } from './BookingFlowErrorLayout'

export const EventListNotFound = () => {
  return (
    <BookingFlowErrorLayout minH="100vh">
      <VStack paddingX={8}>
        <Text textStyle="h5">{"We can't find that event list."}</Text>

        <Text>{'Please contact the agency that gave you this link.'}</Text>
      </VStack>
    </BookingFlowErrorLayout>
  )
}
